import React from 'react';

const Business = ({className, style, settings}) => (
  <div className={className} style={{...style,bottom:settings.bottom,right:settings.right}}>
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><circle id="a" cx={18} cy={18} r={18} /></defs><g transform="translate(-49.000000, -1038.000000) translate(49.000000, 1038.000000)" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd"><use fill="#A7D4EE" xlinkHref="#a" /><g transform="translate(6.967742, 8.129032)"><path stroke="#333" d="M13.373.67L5.99 5.094" strokeWidth="1.67" /><polyline stroke="#333" strokeWidth="1.67" points="11.2830581 0.100428387 13.9265294 0.337563871 12.9027834 2.69010581" /><path stroke="#333" d="M3.39 19.71H.34a.235.235 0 0 1-.237-.232V13.29c0-.128.106-.233.237-.233h3.05c.131 0 .237.105.237.233v6.188a.235.235 0 0 1-.237.232zm5.956 0h-3.05a.235.235 0 0 1-.238-.232v-9.72c0-.128.106-.232.237-.232h3.05c.132 0 .238.104.238.233v9.72a.235.235 0 0 1-.237.231zm6.163 0h-3.05a.235.235 0 0 1-.237-.232V6.117c0-.128.106-.232.237-.232h3.05c.131 0 .238.104.238.232v13.361a.235.235 0 0 1-.238.232zm6.164 0h-3.05a.235.235 0 0 1-.237-.232V2.812c0-.128.106-.232.237-.232h3.05c.131 0 .237.104.237.232v16.666a.235.235 0 0 1-.237.232z" strokeWidth="1.67" /></g></g></svg>
  </div>
);

Business.defaultProps = {
  settings: {
    bottom:0,
    right:0,
  },
  style: {
    position:"absolute",
    zIndex:"500",
  },
};
export default Business;
